import classNames from 'classnames';
import { HTMLProps, ReactNode } from 'react';
import { Badge } from 'yoso';
import styles from './QuickMenuItem.module.scss';

export type QuickMenuItemProps = {
  image: HTMLImageElement['src'] | JSX.IntrinsicElements['img'];
  label: string;
  description?: ReactNode;
  active?: boolean;
} & HTMLProps<HTMLDivElement>;

export const QuickMenuItem = ({
  className,
  image,
  label,
  description,
  active,
  ...props
}: QuickMenuItemProps) => (
  <div className={classNames(styles.root, className)} {...props}>
    <div className={styles.imageContainer}>
      {typeof image === 'string' ? <img src={image} alt={label} className={styles.image} /> : image}
      {active && <Badge className={styles.badge} color="secondary" size="small" variant="dot" />}
    </div>
    <div className={styles.body}>
      <div className={styles.label}>{label}</div>
      {description && <div className={styles.description}>{description}</div>}
    </div>
  </div>
);
